import { ref, Ref } from "vue";

import login from "@/csdPublic/login";
import { getStorage, removeStorage, setStorage } from "@/utils/storage";

import useStore from "@/stores/publicStore";
import { storeToRefs } from "pinia";

const showLoginDialog: Ref<boolean> = ref(false);
const loginCodeUrl: Ref<string> = ref("");
const validCode: Ref<boolean> = ref(true);
const verifyTime: Ref<number> = ref(0);

//解析url
const getOrigin = () => {
  let url = new URL(window.location.href);
  const urlSplitJoin = url.origin + "#/brank";

  return urlSplitJoin;
};

const openLoginDialog = () => {
  getOrigin();
  const bool = login.isWeiXinEnv();
  if (bool) {
    login.loginWeiXin(
      getOrigin(),
      "https://appcloud.api.pcdashi.cn/api/wechat/oauth"
    );
  } else {
    getLoginCode();
    showLoginDialog.value = true;
  }
};

const closeLoginDialog = () => {
  showLoginDialog.value = false;
  stopLoginPoll();
};

const getLoginCode = async () => {
  try {
    // 获取登录二维码
    const res = await login.getLoginCode();
    loginCodeUrl.value = res.codeUrl;
    validCode.value = true;
    // 登录的轮询
    const poll = await login.loginPoll();
    setStorage("token", poll.token);
    ElMessage.success("登录成功");
    closeLoginDialog();
    const publicStore = useStore();
    const { changeUserInfo, changeVipInfo } = publicStore;
    const { isLogin } = storeToRefs(publicStore);
    isLogin.value = true;
    changeUserInfo();
    changeVipInfo();
  } catch (e: any) {
    if (e.code === 1000) validCode.value = false;
  }
};

const stopLoginPoll = () => {
  login.stopInterval();
};

// 手机号码验证
const phoneNumberVerify = (phone: number | string) => {
  if (phone == "") {
    ElMessage.warning("请输入手机号码");
    return false;
  }
  let reg = /^(?:(?:\+|00)86)?1[0-9]{10}$/;
  if (!reg.test(phone.toString())) {
    ElMessage.warning("手机号码格式不正确");
    return false;
  }
  return true;
};

// 计算还剩多少时间可以重新获取
const calcVerifyTime = () => {
  if (getStorage("verifyCodeEndTime")) {
    let verifyCodeEndTime = getStorage("verifyCodeEndTime");
    let nowTime = new Date().getTime();
    if ((verifyCodeEndTime as any) - nowTime > 0) {
      return Math.floor(((verifyCodeEndTime as any) - nowTime) / 1000);
    }
  }
  return 0;
};
// 每秒计算一次重新获取的时间
const verifyCodeTimer = () => {
  let timer = setInterval(() => {
    verifyTime.value = calcVerifyTime();
    if (verifyTime.value === 0) {
      clearInterval(timer);
    }
  }, 1000);
};

const getVerifyResult = (phoneNumber: string) => {
  // 手机号验证
  if (!phoneNumberVerify(phoneNumber)) {
    return false;
  }
  let verifyCodeEndTime = getStorage("verifyCodeEndTime");
  let nowTime = new Date().getTime();
  // 等待重新获取时不允许重复获取验证码
  if (verifyCodeEndTime && nowTime < +verifyCodeEndTime) {
    return false;
  }
  setStorage("verifyCodeEndTime", new Date().getTime() + 1000 * 60);
  return true;
};

// 获取验证码
const getVerifyCode = async (phoneNumber: string) => {
  if (!getVerifyResult(phoneNumber)) return;
  try {
    await login.getPhoneVerifyCode(phoneNumber);
    verifyTime.value = 59;
    verifyCodeTimer();
  } catch (e: any) {
    // 弹出错误信息
    ElMessage.error(e.msg);
    removeStorage("verifyCodeEndTime");
    verifyTime.value = 0;
  }
};

const phoneLogin = async (form: any) => {
  if (!phoneNumberVerify(form.phoneNumber)) return;
  if (!form.code) {
    ElMessage.warning("请输入验证码");
    return;
  }
  try {
    const data = await login.phoneLogin(form.phoneNumber, form.code);
    setStorage("token", data.token);
    ElMessage.success("登录成功");
    closeLoginDialog();
    const publicStore = useStore();
    const { changeUserInfo, changeVipInfo } = publicStore;
    const { isLogin } = storeToRefs(publicStore);
    isLogin.value = true;
    changeUserInfo();
    changeVipInfo();
  } catch (e: any) {
    ElMessage.error(e.msg);
  }
};

export {
  phoneNumberVerify,
  showLoginDialog,
  loginCodeUrl,
  validCode,
  verifyTime,
  openLoginDialog,
  closeLoginDialog,
  getLoginCode,
  stopLoginPoll,
  getVerifyCode,
  phoneLogin,
};
